export function fetchKreditdata(id) {
    return { type: 'KREDITDATA_FETCH_REQUEST', payload: { id } };
}

export function fetchPartnerKreditdata(id, userId) {
    return { type: 'KREDITDATA_FETCH_PARTNER_REQUEST', payload: { id, userId } };
}
